import { NavbarWrapper } from './wrapper';
import { Navbar } from './navbar';
import { NavbarMobileBottom } from './mobile-bottom';
import { DesktopSubMenu } from './desktop-submenu';
import { MobileSubMenu } from './mobile-submenu';
import type { NavbarServerProps } from './type';
import { useMemo } from 'react';
import { Page } from '@jlg-website/database/types/page';

type NonEmptyArray<T> = [T, ...T[]];

function hasPages<T extends { pages?: Page[] | null }>(
  claimSection: T
): claimSection is T & { pages: NonEmptyArray<Page> } {
  return !!claimSection.pages?.length;
}

export function NavbarServer({
  top,
  isMobile,
  initialTop,
  transitionToTop,
  isScrolled,
  isMenuOpen,
  onToggleMenuOpen,
  hideBadge,
  showFreeCaseReviewButton = true,
  showTalkToSpecialistButton = true,
  claimSections,
  bottom = -100,
  className,
  ctaHref,
  onClickCta,
  phone,
  navLinks,
  hideMobileBottomNav,
}: NavbarServerProps) {
  const submenu = claimSections
    .filter(({ visible }) => visible)
    .filter(hasPages)
    .map(({ name, pages }) => {
      const firstPage = pages.at(0) as Page;

      return {
        label: name,
        url: firstPage ? firstPage.slug : '#',
      };
    });

  const initialState = !isScrolled && !isMenuOpen;

  const onlyNumberPhone = useMemo(() => {
    if (!phone) {
      return '';
    }
    const onlyNumber = phone?.replace(/[^\d]/g, '');
    return `tel:+1${onlyNumber}`;
  }, [phone]);

  return (
    <>
      <NavbarWrapper
        top={top}
        initialTop={initialTop}
        transitionToTop={transitionToTop}
        isMenuOpen={isMenuOpen}
        hideBadge={hideBadge}
        initialState={initialState}
        className={className}
      >
        <Navbar
          initialState={initialState}
          onToggleMenuOpen={onToggleMenuOpen}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          phone={onlyNumberPhone}
          showFreeCaseReviewButton={showFreeCaseReviewButton}
          showTalkToSpecialistButton={showTalkToSpecialistButton}
          navLinks={navLinks}
        />
        <DesktopSubMenu submenu={submenu} />
        <MobileSubMenu
          submenu={submenu}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          showFreeCaseReviewButton={showFreeCaseReviewButton}
          navLinks={navLinks}
        />
      </NavbarWrapper>
      {!hideMobileBottomNav && isMobile && (
        <NavbarMobileBottom
          bottom={bottom}
          phone={onlyNumberPhone}
          ctaHref={ctaHref}
          onClickCta={onClickCta}
          showFreeCaseReviewButton={showFreeCaseReviewButton}
          showTalkToSpecialistButton={showTalkToSpecialistButton}
        />
      )}
    </>
  );
}

export default NavbarServer;
